import {Component,Input,ElementRef, ViewChild,ChangeDetectorRef,Output, EventEmitter} from '@angular/core';

import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { SharedService } from '../../services/shared.service';
import { LoaderService } from '../../services/Spinner.service';
import { LocalStorage } from '../../services/local-storage';
import { PopupLogoutComponent } from '../../users/popup/popup-logout.component';
import { Campaign } from '../../models/compaign';
// import { LyResizingCroppingImages, LyResizingCroppingImagesConfig, CroppedImage } from '../../alyle-ui/resizing-cropping-images';

export interface ConfirmModel {
  title:string;
  message:string;
}

@Component({  
    selector: 'image-croper',
    templateUrl: './imageCroper.component.html',
    providers: [SharedService,PopupLogoutComponent]
})
export class ImageCroperComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  @Output() imageUpdated = new EventEmitter();
//     @ViewChild(LyResizingCroppingImages) img: LyResizingCroppingImages;
//   myConfig: LyResizingCroppingImagesConfig = {
//     width: 150, // Default `250`
//     height: 150 // Default `200`
//   };
 // imageUpdated: EventEmitter<any> = new EventEmitter;
  campaign=new Campaign();
  title: string;
  message: string;
  
  croppedWidth: number=560;
  croppedHeight: number=184;
  imageData: any = [];
  imageDta: any;
  data1: any;
  blob:any;
  Img:any;
  imageUrl:any;
  imageloaderFlag:boolean=false;
  imageFlag:boolean=true;
  user:string="dsfsdf";
  @ViewChild('imgBox') imgBox;
  
  constructor(dialogService: DialogService,private localstorage:LocalStorage,private shareService: SharedService,private loaderService: LoaderService) {
    super(dialogService);
     
   // this.imageCropper();
  } 

  
    

b64toBlobNew(b64Data,contentType){
      var byteCharacters = atob(b64Data);
      var byteNumbers = new Array(byteCharacters.length);
for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
}

var byteArray = new Uint8Array(byteNumbers);
var blob = new Blob([byteArray], {type: contentType});
return blob;
  }
    fileChangeListener($event) {
        this.imageFlag=false;
        this.imageDta = $event.target.files;

        var image: any = new Image();
        var file: File = $event.target.files[0];
        var myReader: FileReader = new FileReader();
        var that = this;
        document.getElementsByTagName("canvas")[0].style.display = "block";
        myReader.onloadend = (loadEvent: any) => {
            // image.src = loadEvent.target.result;
            var imageDta = loadEvent.target.result;
            let type = imageDta.split(';')[0].split(':')[1];


            var extention = type.split("/")[1];
            //let type = this.imageDta.split(';')[0].split(':')[1];
            //let extension=type.splif("/")[1];
            this.urltoFile(imageDta, 'croped.' + extention, type).then((result) => {
                this.imageDta[0] = result;

            });

            //  that.cropper.setImage(image);
        };
        var t = myReader.readAsDataURL(file);

    }
    urltoFile(url, filename, mimeType) {
        return (fetch(url)
            .then(function (res) {
                return res.arrayBuffer();
            })
            .then(function (buf) {
                return new File([buf], filename, {
                    type: mimeType
                });
            })
        );
    }
    getImageUrl(imageUrl) {
        console.log("getImageUrl");
        
        var arg={imageurl:"hello"};
        console.log(arg);
        let isValid = this.imageUpdated.emit(arg) || true;
        if (isValid) {
            console.log("emit value");
            // Do stuff
        } else {
            console.log("not emit value");
        }
    }
    
    checkimageURL(url) {
        if (url) {
            return (url.match(/\.(jpeg|jpg|JPG|gif|png)$/) != null);
        }

    }
  confirm() {
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }
  cropImage(img) {
      this.imageloaderFlag=true;
      let type = img.imgCrop.split(';')[0].split(':')[1];
      var extention = type.split("/")[1];
      var b64 = img.imgCrop.split(',');
      this.blob = this.b64toBlobNew(b64[1],type);
      let formData: FormData = new FormData();
        console.log(formData);
        formData.append('banner',this.blob);
        var token = this.localstorage.getStorage("token");
        var campaignId = this.localstorage.getStorage("campaignId");
        if (campaignId == '' || campaignId == null) {
            campaignId = 0;
        }
        this.loaderService.displayLoader(true);
         this.shareService.uploadImage("adv/profile/campaign/banner/" + campaignId, formData, token).subscribe((result) => {
            if (result.data) {
                console.log(result.data);
                for(var j=0; j<5;j++) {
                    var pView=document.getElementsByClassName("campaignImage")[j];
                    pView.setAttribute("src",result.data.imgUrl);
                }
                this.getImageUrl(result.data.imgUrl);
                
                //this.createObj.setImagurl(result.data.imgUrl);
                this.imageUrl=result.data.imgUrl;
                    this.campaign.campaignImage = result.data.imgUrl;

              
                setTimeout(() => {
                    this.cancel();
                    this.imageloaderFlag = false;
                    this.loaderService.displayLoader(false);
                }, 3000);

            } else {
                this.campaign.loaderFlag = false;
                this.loaderService.displayLoader(false);
             }
            
        });

  }
  
}



// WEBPACK FOOTER //
// ./src/app/advertiser/popup/imageCroper.component.ts